import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'

import { verifyEmailRoute } from './verifyEmail/route'

export const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  validateSearch: z.object({
    email_verification: z
      .enum(['failed', 'success'])
      .nullish()
      .transform((data) => data ?? undefined),
  }),
  beforeLoad: ensureAuthenticatedUser,
}).lazy(() => import('./settings').then((d) => d.Route))

export { verifyEmailRoute }
